import $ from 'jquery';

let dropdown = $('.js-business-dropdown');
let copyToClipboards = document.querySelectorAll('.copyToClipboard');

$(document).ready(function () {
    if (dropdown.children().length <= 1) {
        callAjaxOnClick();
    } else {
        callAjaxOnChange();
    }

    copyToClipboards.forEach( (item) => {
        item.addEventListener('click', () => {
            let input = item.previousElementSibling;
            console.log(input.value);
            input.focus();
            input.select();
            input.setSelectionRange(0, 99999); /* For mobile devices */

            navigator.clipboard.writeText(input.value).then(function() {
                console.log('Async: Copying to clipboard was successful!');
            }, function(err) {
                console.error('Async: Could not copy text: ', err);
            });

            item.innerHTML = 'Copied';
            item.disabled = true;
        })
    })
})

function callAjaxOnChange() {
    dropdown.on('change', function () {

        $.ajax({
            type: 'GET',
            url: '/business-controller/set-current-business/' + $(this).val(),
            success: function (data) {
                console.log('success');
                $(location).prop('href', window.dashboardURL)
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log('error');
            }
        });
    })
}

function callAjaxOnClick() {
    dropdown.on('click', function (ev) {
        $.ajax({
            type: 'GET',
            url: '/business-controller/set-current-business/' + $(this).children(':selected').val(),
            success: function (data) {
                console.log('success');
                $(location).prop('href', window.dashboardURL)
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log('error');
            }
        });
    });
}

